class CaseStudiesFilter extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.selectedOptions = [];
    this.categoryNames = [];
    this.selects = [];
  }

  connectedCallback() {
    this.initializeComponent();
  }

  initializeComponent() {
    this.renderTemplate();
    this.setupEventListeners();
  }

  renderTemplate() {
    this.shadowRoot.innerHTML = `<slot></slot>`;
  }

  setupEventListeners() {
    const slot = this.shadowRoot.querySelector('slot');
    slot.addEventListener('slotchange', this.handleSlotChange.bind(this));
  }

  handleSlotChange(event) {
    this.selects = event.target.assignedElements().filter((el) => el.tagName === 'SELECT');
    this.selects.forEach((select) => {
      select.addEventListener('change', this.handleFilterChange.bind(this));
    });
    this.updateSelectedOptions();
    this.updateCategoryNames();
    
    // Dispatch initial filter state
    this.dispatchEvent(
      new CustomEvent('filter-initialized', {
        detail: { selectedOptions: this.selectedOptions, categoryNames: this.categoryNames },
        bubbles: true,
        composed: true,
      }),
    );
  }

  updateSelectedOptions() {
    this.selectedOptions = this.selects.map((select) =>
      select.value === select.options[0].value ? select.options[0].value : select.value,
    );
  }

  updateCategoryNames() {
    // for some reason the endpoint always wants to have all option values
    // of the category select, even if it's not used.
    const categorySelect = this.querySelector('#categories-select');
    if (categorySelect) {
      this.categoryNames = Array.from(categorySelect.options).map((option) => option.value);
    }
  }

  handleFilterChange() {
    this.updateSelectedOptions();
    this.dispatchFilterChangedEvent();
  }

  dispatchFilterChangedEvent() {
    this.dispatchEvent(
      new CustomEvent('filter-changed', {
        detail: { selectedOptions: this.selectedOptions, categoryNames: this.categoryNames },
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define('case-studies-filter', CaseStudiesFilter);
